export const getDataTicket = (payload) => {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(payload)
    var xhr = new XMLHttpRequest()
    xhr.addEventListener('readystatechange', function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          return resolve(JSON.parse(this.responseText))
        } else {
          return reject('fail')
        }
      }
    })
    xhr.addEventListener('error', (event) => {
      return reject('fail')
    })
    xhr.open('POST', 'https://r1ee01cflf.execute-api.ap-southeast-1.amazonaws.com/prod/register')
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.setRequestHeader(
      'Authorization',
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxZmU3YWYxYi0zNWY1LTQ1YjgtOTRlYi0yMjQyMDdmOWUzNDMiLCJpYXQiOjB9.kAMBHZU5q2_yUg7hsx3mmbLZ5a6D8xNnco08LTTife8',
    )
    xhr.send(data)
  })
}

export const sendDataHsForm = (payload) => {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(payload)
    var xhr = new XMLHttpRequest()
    xhr.addEventListener('readystatechange', function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          return resolve(JSON.parse(this.responseText))
        } else {
          return resolve(JSON.parse(this.responseText))
        }
      }
    })
    xhr.addEventListener('error', (event) => {
      return reject('fail')
    })
    xhr.open(
      'POST',
      'https://api.hsforms.com/submissions/v3/integration/submit/2500439/e1db7f94-bec5-42c5-bd67-2738184193fe',
    )
    xhr.setRequestHeader('Content-Type', 'application/json')
    // xhr.setRequestHeader('Content-Length', Buffer.byteLength(data))
    xhr.send(data)
  })
}

export const getS3 = () => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.addEventListener('readystatechange', function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          return resolve(JSON.parse(this.responseText))
        } else {
          return reject('fail')
        }
      }
    })
    xhr.addEventListener('error', (event) => {
      return reject('fail')
    })
    xhr.open(
      'GET',
      'https://signupspace-site.s3.ap-southeast-1.amazonaws.com/da999d7a-c164-a21a-bcf7-32cb27298727/sprout-session.json',
    )
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send()
  })
}
